import { Box, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useCurrentTab } from 'shared/hooks';
import UseDynamicUrl from 'shared/hooks/useDynamicUrl';

const CATALOG = 'Catalog';
const EXCLUSIVE = 'Exclusive';
const PRIVATE = 'Private';

export function DeviationFilters() {
    const currentTab = useCurrentTab({
        orderedTabList: [CATALOG, EXCLUSIVE, PRIVATE],
    });
    const [activeTab, setActiveTab] = useState(currentTab);

    const tabChange = useCallback((event, value: string) => {
        setActiveTab(value);
    }, []);

    const exclusivePath = UseDynamicUrl({ route: ROUTES.addDeviationsExclusive });
    const catalogPath = UseDynamicUrl({ route: ROUTES.addDeviationsCatalog });
    const privatePath = UseDynamicUrl({ route: ROUTES.addDeviationsPrivate });

    useEffect(() => {
        if (activeTab !== currentTab) {
            setActiveTab(currentTab);
        }
    }, [activeTab, currentTab]);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={tabChange}
                    textColor='secondary'
                    indicatorColor='secondary'
                    aria-label='customer details'
                >
                    <Tab value={CATALOG} label={CATALOG} component={ReactRouterLink} to={catalogPath.path} />
                    <Tab value={EXCLUSIVE} label={EXCLUSIVE} component={ReactRouterLink} to={exclusivePath.path} />
                    <Tab value={PRIVATE} label={PRIVATE} component={ReactRouterLink} to={privatePath.path} />
                </Tabs>
            </Box>
        </>
    );
}
